module.exports = __webpack_public_path__ + "media/wafoo3.2cda49e9.mp3";